import React from 'react'
import Transition from 'react-transition-group/Transition'

import { EASING } from '~/common/globalStyles'

const duration = 300
const defaultStyle = {
  transition: `opacity ${duration}ms ${EASING.easeOut}`,
  opacity: 0,
}

type TransitionStyles = Record<string, { opacity: number }>

const transitionStyles: TransitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
}

interface FadeProps {
  in: boolean
  children: React.ReactNode
}

const Fade: React.FC<FadeProps> = ({ children, in: inProp }) => {
  return (
    <Transition
      appear
      in={inProp}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 0, exit: duration }}
    >
      {(state) => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  )
}

export default Fade
